var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({class:{ required: _vm.required },attrs:{"validate-on-blur":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-textarea',[_vm.$props, _vm.$attrs],false))
}
var staticRenderFns = []

export { render, staticRenderFns }